﻿import { AdminMetricCard } from "@/components/admin";
import type { AdminStatusTone } from "@/lib/adminCodeDisplay";
import type { LocationSummary } from "../page";

interface SummaryCardsProps {
  summary: LocationSummary;
}

interface LocationSummaryCard {
  title: string;
  value: string;
  badge: string;
  description: string;
  tone: AdminStatusTone;
  icon: string;
}

const SummaryCards = ({ summary }: SummaryCardsProps) => {
  const cards: LocationSummaryCard[] = [
    {
      title: "위치 대상",
      value: `${summary.totalCount}명`,
      badge: "어르신 기준",
      description: "최신 위치 보유 대상",
      tone: "blue",
      icon: "ri-map-pin-line",
    },
    {
      title: "정상 수신",
      value: `${summary.normalCount}명`,
      badge: "24시간",
      description: "권한/제공자 정상",
      tone: "emerald",
      icon: "ri-wifi-line",
    },
    {
      title: "확인 필요",
      value: `${summary.checkNeededCount}건`,
      badge: "권한/제공자",
      description: "위치 수신 설정 확인",
      tone: "orange",
      icon: "ri-alert-line",
    },
    {
      title: "지연/미수신",
      value: `${summary.staleCount}건`,
      badge: "24시간 초과",
      description: "위치 로그 확인 필요",
      tone: "slate",
      icon: "ri-map-pin-2-line",
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((card) => (
        <AdminMetricCard
          key={card.title}
          title={card.title}
          value={card.value}
          badge={card.badge}
          description={card.description}
          tone={card.tone}
          icon={card.icon}
        />
      ))}
    </div>
  );
};

export default SummaryCards;
